import { render, staticRenderFns } from "./MenuPrint.vue?vue&type=template&id=2d81afb6&scoped=true&"
import script from "./MenuPrint.vue?vue&type=script&lang=js&"
export * from "./MenuPrint.vue?vue&type=script&lang=js&"
import style0 from "./MenuPrint.vue?vue&type=style&index=0&id=2d81afb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81afb6",
  null
  
)

export default component.exports